
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui",
      function () {
        return require("private-next-pages/material-ui.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui"])
      });
    }
  